import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CanvasUserTasksGridViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-canvasusertasksgridview" */ "./CanvasUserTasksGridView")).then((page)=>{
        return {
            default: page.CanvasUserTasksGridView
        };
    });
export const LazyCanvasUserTasksGridView = /*#__PURE__*/ lazy(CanvasUserTasksGridViewLazyLoader);
